// extracted by mini-css-extract-plugin
export default {"container":"Oo-z","brandName":"Po-z","productName":"Qo-z","productNamePdpEnhancements":"Ro-z","breakLongProductName":"So-z"};